import * as tslib_1 from "tslib";
import initializeSignatureContent from '../actions/initializeSignatureContent';
import store from '../store/store';
import RibbonPlugin from 'owa-editor-ribbonplugin/lib/plugin/RibbonPlugin';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { ReactEditor } from 'owa-editor';
import { computed } from 'mobx';
import { Ribbon } from 'owa-editor-ribbonplugin';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
var styles = require('./SignatureOption.scss');
var SignatureEditor = /** @class */ (function (_super) {
    tslib_1.__extends(SignatureEditor, _super);
    function SignatureEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.ribbonPlugin = new RibbonPlugin(_this.props.optionStore.ribbon);
        return _this;
    }
    SignatureEditor.prototype.componentDidMount = function () {
        initializeSignatureContent();
    };
    SignatureEditor.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, isRtl = _a.isRtl;
        return (React.createElement("div", { className: styles.editorContainer }, this.isMessageOptionsFetchComplete ? ([
            React.createElement(Ribbon, { key: "ribbon", ribbonPlugin: this.ribbonPlugin, viewState: optionStore.ribbon, className: styles.ribbon }),
            React.createElement(ReactEditor, { key: "editor", isRtl: isRtl, viewState: optionStore.editorViewState, plugins: this.plugins, classNames: styles.editor, updateOnKeyPress: true, ariaLabel: strings.options_signature_aria_label }),
        ]) : (React.createElement("div", { className: styles.loading },
            React.createElement(Spinner, { size: SpinnerSize.medium })))));
    };
    Object.defineProperty(SignatureEditor.prototype, "plugins", {
        get: function () {
            // VSO 14829 - Use a common collection of plugins
            return [this.ribbonPlugin];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignatureEditor.prototype, "isMessageOptionsFetchComplete", {
        get: function () {
            var optionStore = this.props.optionStore;
            return optionStore.editorViewState.content !== null;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], SignatureEditor.prototype, "isMessageOptionsFetchComplete", null);
    SignatureEditor = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
            isRtl: function () { return getUserConfiguration().SessionSettings.IsUserCultureRightToLeft; },
        })
    ], SignatureEditor);
    return SignatureEditor;
}(React.Component));
export default SignatureEditor;
//# sourceMappingURL=SignatureEditor.js.map